"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeviceConfig = exports.isDeviceContext = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
// misleadingly named, will be removed
const isDeviceContext = (x) => {
    const c = x;
    return (0, iotv_v3_types_1.isVOBofType)('DeviceConfig', c);
};
exports.isDeviceContext = isDeviceContext;
const isDeviceConfig = (x) => {
    const c = x;
    return !!c && c.type === 'DeviceConfig' && c.metadata !== undefined && c.recentReported instanceof Array && c.recentRequested instanceof Array;
};
exports.isDeviceConfig = isDeviceConfig;
